<template>
  <div class="wd-pt-5">
    <Lottie :width="72" :height="72" v-bind="lottieOptions" />
  </div>
</template>

<script>
import { watchOnce } from '@vueuse/core'
import animationData from '@/assets/images/icon/loading.json'
import * as memberService from '@/service/member'

export default defineComponent({
  setup() {
    const { $axios, $auth, $store: store, $cookiz } = useNuxtApp()
    const route = useRoute()
    const router = useRouter()
    const userInfo = computed(() => $auth.user)
    const recTradeId = computed(() => route.query.rec_trade_id)

    watchOnce(userInfo, async newUserInfo => {
      if (newUserInfo) {
        await verifyElite()
      }
    })

    function verifyElite() {
      return memberService
        .verifyElite($axios, { rec_trade_id: recTradeId.value })
        .then(() => {
          const newUserInfo = {
            ...userInfo.value,
            is_elite: true,
          }

          if (store.getters['authentication/getUser']) {
            store.commit('authentication/UPDATE_USER_IS_ELITE', true)
          }
          $auth.$storage.setUniversal('user', newUserInfo)
        })
        .catch(err => {
          console.error('verifyElite errors, error message is: ', err.message)
          $cookiz.set('eliteErrorCode', err.code)
        })
        .finally(() => {
          router.replace($cookiz.get('eliteRedirectTo') || '/elite-redemption')
        })
    }

    return {
      lottieOptions: { animationData },
    }
  },
})
</script>
